import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router'
import { trpc } from '@/lib/trpc'
import PageLoading from '@/components/PageLoading'

/**
 * RFC-211 M4 — a device is a DEVICE-type Asset. There is no separate device
 * detail page; `/devices/$deviceId` resolves the linked Asset spine and
 * redirects to the converged asset detail (Endpoint tab). Unlinked devices
 * (no Asset yet) fall back to the People > Devices tab.
 */
export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/devices_/$deviceId'
)({
  component: DeviceRedirectPage,
  staticData: { pageHeader: { title: 'Device', pad: false } },
})

function DeviceRedirectPage() {
  const { workspaceId, deviceId } = useParams({ strict: false }) as {
    workspaceId: string
    deviceId: string
  }
  const navigate = useNavigate()
  const deviceQuery = useQuery(trpc.device.get.queryOptions({ id: deviceId }))

  useEffect(() => {
    if (deviceQuery.isLoading) return
    const assetId = deviceQuery.data?.assetId
    if (assetId) {
      navigate({
        to: '/workspaces/$workspaceId/assets/$assetId',
        params: { workspaceId, assetId },
        search: { tab: 'endpoint' },
        replace: true,
      })
    } else {
      navigate({
        to: '/workspaces/$workspaceId/people',
        params: { workspaceId },
        replace: true,
      })
    }
  }, [deviceQuery.isLoading, deviceQuery.data, navigate, workspaceId])

  return <PageLoading />
}
